import { type ReactElement } from 'react'

import { type IconSprites } from '@constants/enums/sprites'

import { Icon } from '@components/ui-core/icon/icon'
import { Row } from '@components/ui-core/row/row'
import { Text } from '@components/ui-core/text/text'

import { type ProductAvailability, type Product, Products } from '../types'

import styles from './product-icons.module.scss'

export function ProductIcons({
  availability,
}: {
  readonly availability: ProductAvailability
}): ReactElement[] {
  return Products.filter(product => availability[product] === 'available').map(productIcon)
}

const productIcon = (product: Product): ReactElement => (
  <Row
    key={product}
    className={styles.productIconRow}
    mainAxisAlignment="start"
    crossAxisAlignment="center"
    gap="2x"
  >
    <Icon variant={`${product}-icon` as IconSprites} className={styles.icon} aria-hidden="true" />
    <Text as="span" variant="headerSmall" className={styles.productName}>
      {product}
    </Text>
  </Row>
)
